{
  "version": 1,
  "asset_id": "cb84ff3c-0112-41c2-a29c-920b53d9c3a2",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/cb84ff3c-0112-41c2-a29c-920b53d9c3a2/destination-roofing-crew-citrus-county-fl-480.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/cb84ff3c-0112-41c2-a29c-920b53d9c3a2/destination-roofing-crew-citrus-county-fl-480.avif",
  "original_filename": "destination-roofing-crew-citrus-county-fl-480.avif",
  "size": 11982,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:33Z"
}
